export default __webpack_public_path__ + "static/preview-06cc50c272413fd89e471a587b160f70.jpg";